(function() {
    const passwordField = document.getElementById('femanager_field_password');
    const passwordRepeatField = document.getElementById('femanager_field_password_repeat');

    // Global functions for inline onclick handlers
    window.femanager_field_password_eye_on_off = function() {
        if (!passwordField) return;
        passwordField.type = passwordField.type === 'password' ? 'text' : 'password';
    };

    window.femanager_field_password_duplicate = function() {
        if (!passwordField || !passwordRepeatField) return;
        passwordRepeatField.value = passwordField.value;
    };

    // Mirror into the hidden repeat field on every keystroke and on autofill, and once more right
    // before submit (capture phase, ahead of femanager's own validation) for password managers
    // that set the value without firing any event.
    const syncRepeatField = () => {
        if (passwordField && passwordRepeatField) {
            passwordRepeatField.value = passwordField.value;
        }
    };
    passwordField?.addEventListener('input', syncRepeatField);
    passwordField?.addEventListener('change', syncRepeatField);
    passwordField?.form?.addEventListener('submit', syncRepeatField, true);
})();